<template lang="pug">
  div
    TextBox(
      :error-messages="errors.name",
      :label="$t('form.shop.name')",
      :value.sync="model.name"
      @update:value="clearError('name')",
    )

    TextBox(
      :error-messages="errors.address",
      :label="$t('form.shop.address')",
      :value.sync="model.address"
      @update:value="clearError('address')",
    )

    RadioGroup(
      :error-messages="errors.country",
      :label="$t('form.shop.country')",
      :list="countries",
      :value.sync="model.country",
      @update:value="country = $event; clearError('country');",
    )

    Phone(
      :country="country",
      :error-messages="errors.telephone_no",
      :extension-label="$t('form.shop.extension')",
      :label="$t('form.shop.mobile_number')",
      :value.sync="model.telephone_no",
      @update:value="clearError('telephone_no')",
    )

    v-row(no-gutters)
      .flex-grow-1
      v-btn.mt-4(
        color="primary",
        :disabled="hasError || !valid",
        :ripple="false",
        :loading="isLoading",
        @click="submit",
      ) {{ $t(`form.shop.${ isEdit ? 'update': 'create'}`) }}
</template>

<script>
import { mergeRight } from 'ramda';
import { formHelper } from '@/config/mixins';
import { addExtensionCode } from '@/utils/helper';
import { countries } from '@/constant';

export default {
  mixins: [formHelper],

  data() {
    return {
      country: this.model.country,
      countries,
    };
  },

  methods: {
    submit() {
      if (this.validate()) {
        const payload = mergeRight(this.model, {
          telephone_no: addExtensionCode(
            this.model.country,
            this.model.telephone_no,
          ),
        });

        const action = this.isEdit ? 'update' : 'create';

        this.wrapProgress(() =>
          this.$store
            .dispatch(`shop/${action}`, payload, {
              root: true,
            })
            .then(() => this.$router.push({ name: 'shops' }))
            .catch(this.setError),
        );
      }
    },
  },
};
</script>
